import styled from "styled-components";
import { paletas } from "../../styles/theme";

export const Wrapper = styled.button`
  position: relative;
  width: 100%;
  font-size: 20px;
  color: ${paletas.White};
  border: none;
  border-radius: 0.25rem;
  padding: 10px 0;
  transition: all 0.25s;
  text-transform: uppercase;
  background: ${paletas.Grafite75};

  @media (max-width: 420px) {
    font-size: 16px;
  }

  @media (max-width: 320px) {
    font-size: 14px;
  }
`;

export const BoxIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -10px;
  margin-right: -10px;

  svg {
    transform: rotate(15deg);
  }

  &.disabled {
    opacity: 0.1;
  }
`;
